import { ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export function TMSLessonNav({ prev, next }) {
  return (
    <div data-testid="tms-lesson-nav" className="flex flex-col sm:flex-row items-center justify-between border-t border-border/60 mt-20 pt-8 pb-16 gap-6">
      {prev ? (
        <Link to={`/themuscleschool/lessons/${prev.id}`} data-testid="tms-lesson-nav-prev" className="font-meta text-xs uppercase tracking-widest text-textSecondary hover:text-primary transition-colors flex items-center gap-2">
          <ChevronLeft className="w-3.5 h-3.5" /> Previous Lesson
        </Link>
      ) : <span />}
      <Link to="/themuscleschool" data-testid="tms-lesson-nav-curriculum" className="font-display text-sm text-primary">Curriculum</Link>
      {next ? (
        <Link to={`/themuscleschool/lessons/${next.id}`} data-testid="tms-lesson-nav-next" className="font-meta text-xs uppercase tracking-widest text-textSecondary hover:text-primary transition-colors flex items-center gap-2">
          Next Lesson <ChevronRight className="w-3.5 h-3.5" />
        </Link>
      ) : <span />}
    </div>
  );
}
